import { createFileRoute } from "@tanstack/react-router";
import { pageMeta } from "@/lib/seo";

export const Route = createFileRoute("/privacy-policy")({
  head: () =>
    pageMeta({
      path: "/privacy-policy",
      title: "Política de privacidad — Truck Company Center",
      description:
        "Política de privacidad de Truck Company Center: qué datos recopilamos y cómo los usamos para procesar pedidos de trucking companies.",
    }),
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-12 md:px-6">
      <h1 className="font-display text-3xl font-semibold text-foreground md:text-4xl">Política de privacidad</h1>
      <div className="mt-8 space-y-5 text-sm leading-relaxed text-muted-foreground">
        <p>Truck Company Center es la marca comercial bajo la que operamos.</p>
        <p>Recopilamos información necesaria para procesar pedidos, contactar al cliente y realizar servicios administrativos relacionados con car carrier / auto transport.</p>
        <p className="font-medium text-foreground">La información que podemos recopilar incluye:</p>
        <ul className="ml-5 list-disc space-y-1.5">
          <li>nombre completo;</li>
          <li>teléfono;</li>
          <li>email;</li>
          <li>nombre de compañía;</li>
          <li>dirección de negocio o postal;</li>
          <li>estado donde opera o desea operar;</li>
          <li>información relacionada con LLC, EIN, USDOT, MC, Central Dispatch, Super Dispatch, tipo de truck, tipo de trailer, rutas, documentos y necesidades del servicio;</li>
          <li>notas o documentos que el cliente decida subir o compartir.</li>
        </ul>
        <p className="font-medium text-foreground">Usamos esta información para:</p>
        <ul className="ml-5 list-disc space-y-1.5">
          <li>procesar pedidos;</li>
          <li>preparar documentos;</li>
          <li>organizar solicitudes;</li>
          <li>comunicarnos con el cliente;</li>
          <li>dar seguimiento al proceso;</li>
          <li>enviar confirmaciones;</li>
          <li>cumplir requisitos administrativos;</li>
          <li>mejorar nuestros servicios.</li>
        </ul>
        <p>Los pagos se procesan mediante Stripe. No almacenamos datos completos de tarjetas de crédito o débito en nuestra base de datos.</p>
        <p>Podemos compartir información limitada con terceros solo cuando sea necesario para completar el servicio, por ejemplo: agencias estatales, plataformas privadas, proveedores, aseguradoras, servicios de pago, servicios de email, imprentas o proveedores relacionados con el pedido.</p>
        <p>No vendemos información personal del cliente.</p>
        <p>El cliente puede contactarnos para solicitar actualización o corrección de su información.</p>
        <p>Tomamos medidas razonables para proteger la información, pero ningún sistema digital puede garantizar seguridad absoluta.</p>

        <h2 className="pt-4 font-display text-lg font-semibold text-foreground">Cookies y herramientas de medición</h2>
        <p>
          Para entender cómo se usa el sitio y mejorar nuestros servicios, podemos cargar herramientas de
          analítica y marketing a través de un único contenedor de etiquetas (Google Tag Manager). Las
          herramientas que pueden activarse son:
        </p>
        <ul className="ml-5 list-disc space-y-1.5">
          <li>Google Tag Manager (contenedor de etiquetas);</li>
          <li>Google Analytics 4 (medición de tráfico y comportamiento);</li>
          <li>Meta Pixel (medición de campañas en Facebook/Instagram);</li>
          <li>TikTok Pixel (medición de campañas en TikTok);</li>
          <li>Microsoft Clarity (mapas de calor y grabaciones anónimas de sesión);</li>
          <li>Google Search Console (verificación del sitio mediante una etiqueta meta, no usa cookies).</li>
        </ul>
        <p>
          Al entrar al sitio aparece un banner donde puedes <strong>aceptar</strong> o <strong>rechazar</strong>{" "}
          las cookies de medición y marketing. Por defecto, esas cookies están desactivadas hasta que aceptes
          (Consent Mode v2). Tu decisión se guarda en tu navegador (almacenamiento local). Puedes cambiarla en
          cualquier momento borrando los datos del sitio en tu navegador; el banner aparecerá de nuevo.
        </p>
        <p>
          <strong>No enviamos a estas herramientas</strong> tu email, teléfono, SSN, ITIN ni datos sensibles del
          formulario. Tampoco enviamos los enlaces privados de tus pedidos o formularios. La información
          enviada se limita a eventos anónimos de uso del sitio (vistas de página, productos vistos, agregar al
          carrito, iniciar checkout, compras y clics de contacto).
        </p>

        <p className="pt-4 text-xs text-muted-foreground">Última actualización: 2026.</p>
      </div>
    </div>
  );
}
